import React, { useEffect, useState } from "react";
import Logo from '../assets/images/logo.svg';
import Bag from '../assets/images/bag.svg';
import Profile from '../assets/images/profile.svg';
import { useNavigate } from "react-router-dom";
import routes from "../layout/Routes";
import Skeleton from "react-loading-skeleton";
import { useCart } from '../context/CartContext';
import {
  getNoticationsApi,
  deleteNotificationApi,
  getNotificationDetailApi
} from "./actioncreator";
import moment from 'moment';

const Header = ({ setSearchTerm, searchTerm }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [selectedNotificationDetail, setSelectedNotificationDetail] = useState(null);
  const { cartData } = useCart();
  const cartItemCount = cartData?.items?.length || 0;
  const navigate = useNavigate();
  const token = localStorage.getItem("btoken");

  const closeModals = () => {
    const modals = document.querySelectorAll('.modal.show');
    modals.forEach(modal => {
      const modalInstance = window.bootstrap.Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide();
      }
    });
  };

  const handleNavigate = (path) => {
    closeModals();
    navigate(path);
  };

  const logout = () => {
    closeModals();
    navigate(routes.LOGIN);
  };

  const gotoHome = (value) => {
    setSearchTerm(value);
    navigate(routes.CREATOR);
  };

  const fetchNotifications = () => {
    getNoticationsApi(token, callback => {
      setNotificationData((callback || []).slice().reverse());
    });
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleDeleteNotification = (id) => {
    deleteNotificationApi(id, token, res => {
      if (res.success !== false) {
        fetchNotifications();
      } else {
        console.error("Failed to delete notification", res.error);
      }
    });
  };

  const handleViewNotificationDetail = (id) => {
    getNotificationDetailApi(id, token, res => {
      // if (res.success !== false) {
      setSelectedNotificationDetail(res);
      const modal = new window.bootstrap.Modal(document.getElementById('notificationDetailModal'));
      modal.show();
      // } else {
      //   console.error("Failed to fetch detail", res.error);
      // }
    });
  };
  const truncate = (text = '', length = 50) => {
    return text.length > length ? `${text.substring(0, length)}...` : text;
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light nav-happer fixed-top">
        <div className="container">
          <a className="navbar-brand" href="#" onClick={(e) => { e.preventDefault(); handleNavigate(routes.CREATOR); }}>
            <img src={Logo} alt="Logo" />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item margin-mobile">
                <div className={`search-div ${isZoomed ? "zoomed" : ""}`} onClick={() => setIsZoomed(!isZoomed)} data-bs-toggle="modal" data-bs-target="#searchModal" style={{ cursor: 'pointer' }}>
                  {searchTerm ? searchTerm : 'Search'}
                  <i style={{ float: 'right', marginTop: '5px' }} className="fa fa-search" />
                </div>
              </li>
              <li className="nav-item margin-mobile" style={{ position: 'relative', marginTop: '4px', width: '50px' }}>
                <img
                  onClick={() => navigate(routes.MY_CART)}
                  style={{ marginLeft: '10px', marginRight: '20px', width: '25px', marginTop: '4px', cursor: 'pointer' }}
                  src={Bag}
                  alt="Bag"
                />
                {cartItemCount > 0 && (
                  <span className="notifications">{cartItemCount}</span>
                )}
              </li>
              <li className="nav-item margin-mobile">
                {cartData ? (
                  <img
                    src={cartData?.user_id?.picture || Profile}
                    alt="Profile"
                    style={{ marginTop: '0px', border: '1px solid #000', padding: '2px', borderRadius: '30px', cursor: 'pointer', width: '50px', height: '50px' }}
                    data-bs-toggle="modal"
                    data-bs-target="#profileModal"
                  />
                ) : (
                  <Skeleton circle height={50} width={50} />
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Search Modal */}
      <div className="modal fade" id="searchModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="input-group">
                <input
                  autoFocus
                  className="form-control me-2"
                  type="search"
                  placeholder="Search"
                  onChange={(e) => gotoHome(e.target.value)}
                />
                <span className="input-group-text">
                  <i className="fa fa-search" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Modal */}
      <div className="modal fade profile-modal" id="profileModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body profile-card bg-white">
              <div className="profile-header" style={{ cursor: 'pointer' }}>
                {cartData && (
                  <img
                    src={cartData?.user_id?.picture || Profile}
                    style={{ border: '1px solid #000', padding: '2px', borderRadius: '30px', width: '50px', height: '50px' }}
                    alt="Profile"
                  />
                )}
                <span className="fw-bold">&nbsp;{cartData?.user_id?.first_name} {cartData?.user_id?.last_name}</span>
              </div>
              <ul className="profile-menu">
                <li onClick={() => handleNavigate(routes.USER_PROFILE)}>Profile <span>&#x203A;</span></li>
                <li data-bs-toggle="modal" data-bs-target="#notificationModal">
                  Notifications <span className="notification-badge">{notificationData.length}</span>
                </li>
                <li className="logout" onClick={logout}>
                  Logout <span style={{ color: '#ff0000' }}>&#x203A;</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Modal */}
      <div className="modal fade notification-modal" id="notificationModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body card notification-box bg-white" style={{ height: '300px', overflow: 'auto' }}>
              <div className="notification-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">NOTIFICATIONS</h5>
                <div className="red-dot">{notificationData.length}</div>
              </div>

              {notificationData.length > 0 ? (
                notificationData.map(notification => {
                  const title = notification?.message?.notification?.title || "No Title";
                  const body = notification?.message?.notification?.body || "No message content";
                  const createdAt = moment(notification.created_at).fromNow();

                  return (
                    <div
                      className="notification-item d-flex justify-content-between align-items-start"
                      key={notification._id}
                      onClick={() => handleViewNotificationDetail(notification._id)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="notification-icon text-secondary">
                        <i className="bi bi-bell-fill" />
                      </div>
                      <div className="notification-content flex-grow-1 ms-2">
                        <div className="d-flex justify-content-between">
                          <span className="notification-title">{truncate(title, 30)}</span>
                          <span className="notification-time">{createdAt}</span>
                        </div>
                        <div className="text-muted small">{truncate(body, 70)}</div>
                      </div>

                      <button className="btn btn-sm btn-link text-danger" onClick={(e) => { e.stopPropagation(); handleDeleteNotification(notification._id); }}>
                        <i className="fa fa-trash" />
                      </button>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted mt-3">No notifications available.</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Notification Detail Modal */}
      {/* <div className="modal fade" id="notificationDetailModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Notification Detail</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
            </div>
            <div className="modal-body">
              {selectedNotificationDetail ? (
                <>
                  <h6>{selectedNotificationDetail.title}</h6>
                  <p className="text-muted">{moment(selectedNotificationDetail.created_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                  <p>{selectedNotificationDetail.body}</p>
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div> */}
      {/* Notification Detail Modal */}
      <div className="modal fade" id="notificationDetailModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Notification Detail</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
            </div>
            <div className="modal-body">
              {selectedNotificationDetail ? (
                <>
                  <h6 className="fw-bold">{selectedNotificationDetail.message?.notification?.title || "No Title"}</h6>
                  <p className="text-muted">
                    {moment(selectedNotificationDetail.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                  </p>
                  <p>{selectedNotificationDetail.message?.notification?.body || "No content available."}</p>

                  {/* Show image if available */}
                  {selectedNotificationDetail.message?.android?.notification?.imageUrl ||
                    selectedNotificationDetail.message?.apns?.fcm_options?.image ||
                    selectedNotificationDetail.message?.webpush?.headers?.image ? (
                    <div className="mt-3 text-center">
                      <img
                        src={
                          selectedNotificationDetail.message?.android?.notification?.imageUrl ||
                          selectedNotificationDetail.message?.apns?.fcm_options?.image ||
                          selectedNotificationDetail.message?.webpush?.headers?.image
                        }
                        alt="Notification"
                        style={{ maxWidth: '100%', maxHeight: '250px', borderRadius: '10px' }}
                      />
                    </div>
                  ) : (
                    <div className="text-muted">No image provided.</div>
                  )}

                  {/* Show parameters */}
                  {/* {selectedNotificationDetail.parameter?.length > 0 && (
              <div className="mt-3">
                <h6 className="fw-semibold">Parameters:</h6>
                <ul className="list-group">
                  {selectedNotificationDetail.parameter.map((param, idx) => (
                    <li key={idx} className="list-group-item">{param}</li>
                  ))}
                </ul>
              </div>
            )} */}
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Header;
